import MainDashboardLayout from 'components/Dashboards/MainDashboardLayout';
import PageContentLayout from 'layouts/PageContentLayout';
import React, { useEffect, useState } from 'react';
import PageLayout from '../../../layouts/PageLayout';
import { Alert, Snackbar, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import TitleAndActionSummaryBar from 'components/SummaryBars/TitleAndActionSummaryBar';
import moment from 'moment';
export default function KioskDashboardPage() {
  const [summaryBar, setSummaryBar] = useState(<></>);
  const [isLoading, setIsLoading] = useState(false);
  const [tabAction, setTabAction] = useState<JSX.Element>();
  const [errorMessage, setErrorMessage] = useState('');
  const [selectedToken, setSelectedToken] = useState<string | null>(null);
  const [selectedDashboardName, setSelectedDashboardName] = useState<string>('');
  const [lastUpdated, setLastUpdated] = useState<string>(
    moment.utc().local().format('DD MMM YYYY h:mm A')
  );
  const params = useParams();
  const [timeInterval, setTimeInterval] = useState(0);
  const [timeLeft, setTimeLeft] = useState(5 * 60);
  const [childUpdateKey, setChildUpdateKey] = useState(0);
  const [kioskError, setKioskError] = useState<string>('');

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev === 1) {
          setLastUpdated(moment.utc().local().format('DD MMM YYYY h:mm A'));
          setChildUpdateKey((key) => key + 1); // Trigger child update when reaching 0
          return timeInterval * 60; // Reset timer
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeInterval]);

  const formatTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  React.useMemo(() => {
    const token: string = params.token ?? '';
    if (token) {
      console.log(token);
      setSelectedToken(token);
    }
    return token;
  }, [params]);

  useEffect(() => {
    const title = <>{selectedDashboardName}</>;
    const tabTitle = `${selectedDashboardName}`;
    const summaryBar = (
      <TitleAndActionSummaryBar
        title={title}
        browserTabTitle={tabTitle}
        action={
          kioskError == '' ? (
            <>
              Last Updated: {lastUpdated} | Next Refresh: {formatTime(timeLeft)}
            </>
          ) : (
            <></>
          )
        }
      />
    );
    setSummaryBar && setSummaryBar(summaryBar);
  }, [tabAction, selectedDashboardName, timeLeft, lastUpdated, kioskError]);

  const callBackHandler = (refreshInterval: number) => {
    setTimeInterval(refreshInterval);
    setTimeLeft(refreshInterval * 60);
  };

  return (
    <PageLayout SummaryBar={summaryBar}>
      <Snackbar
        open={errorMessage !== ''}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        onClose={() => setErrorMessage('')}
      >
        <Alert severity="error" onClose={() => setErrorMessage('')}>
          {errorMessage}
        </Alert>
      </Snackbar>
      <PageContentLayout showLoading={isLoading}>
        {kioskError && (
          <Typography
            variant="subtitle2"
            padding={1}
            textAlign="center"
            fontWeight={600}
            component="div"
          >
            {kioskError}
          </Typography>
        )}
        <MainDashboardLayout
          kioskErrorHandler={setKioskError}
          callbackHandler={callBackHandler}
          triggerRefresh={childUpdateKey}
          kioskMode={true}
          kioskToken={selectedToken}
          homeDashboard={false}
          loadingHandler={setIsLoading}
          errorHandler={setErrorMessage}
          setActionHandler={setTabAction}
          setDashboardNameHandler={setSelectedDashboardName}
          editMode={false}
        />
      </PageContentLayout>
    </PageLayout>
  );
}
